import gql from 'graphql-tag'

const query = gql`
	query {
		cashAssist {
			getAppConfig {
		    mainCurrency
			}
		}
	}
`

export default query
